export const STATUS = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    UNASSIGNED: 'UNASSIGNED'
};

export const STOP_STATUS = {
  FAILED: 'FAILED',
};

export const DRIVER_STATUS = {
  QUIT: 'QUIT',
  CREATED: 'CREATED',
  SUSPENDED: 'SUSPENDED'
}

export const DRIVER_BACKGROUND_STATUS = {
  AUTO_APPROVED: 'AUTO_APPROVED',
  MANUAL_APPROVED: 'MANUAL_APPROVED',
  REJECTED: 'REJECTED',
  DRIVER_CONSENTED: 'DRIVER_CONSENTED',
  PENDING: 'PENDING'
};

export const DRIVER_REGISTRATION_STATUS = {
  QUIZ_SENT: 'QUIZ_SENT',
  QUIZ_COMPLETED: 'QUIZ_COMPLETED'
};

export const NOT_ALLOW_APPROVE_DRIVER_STATUS = [
  DRIVER_BACKGROUND_STATUS.AUTO_APPROVED,
  DRIVER_BACKGROUND_STATUS.MANUAL_APPROVED
];

export const NOT_ALLOW_REQUIZ_DRIVER_STATUS = [
  DRIVER_REGISTRATION_STATUS.QUIZ_COMPLETED,
];

export const NOT_ALLOW_RESEND_BACKGROUND_REQUEST_URL = [
  DRIVER_BACKGROUND_STATUS.AUTO_APPROVED, DRIVER_BACKGROUND_STATUS.MANUAL_APPROVED, DRIVER_BACKGROUND_STATUS.REJECTED
];

export const SHIPMENT_SERVICE_LEVEL = {
  NEXT_DAY: 'NEXT_DAY',
  SAME_DAY: 'SAME_DAY',
  ASAP: 'ASAP'
}

export const excludedSignals = ['OUTBOUND.MISSING', 'DISPATCH.ASSIGNED', 'DISPATCH.DRIVER_UNASSIGNED'];